/* Next Gear — checkout confirmation gates.
   Large-order gate: carts at or over $100 (10000 cents) require the
   shopper to tick a confirmation box before the checkout button works.
   The confirmation is stored on the cart as the attribute
   "_large_order_confirmed" = "yes", so it lands on the order. Below
   $100 there is no box and no friction.
   Knife gate: carts containing a product tagged "knife" require a
   second acknowledgment box (see snippets/ng-knife-gate.liquid), stored
   as the cart attribute "_knife_acknowledged" = "yes". Both gates can
   be required at once; each stamps its own attribute. */
(function () {
  var THRESHOLD_CENTS = 30000;
  var ATTRIBUTE_KEY = '_large_order_confirmed';
  var KNIFE_ATTRIBUTE_KEY = '_knife_acknowledged';

  var currentTotalCents = null; // last known cart total, in cents
  var currentItemCount = null; // last known cart item count
  var confirmed = null; // null = not yet read from the server cart
  var lastSyncedValue = null; // last attribute value written to the server
  var hasKnife = null; // null = not yet read from the rendered knife gate markup
  var knifeConfirmed = null; // null = not yet read from the server cart
  var lastKnifeSyncedValue = null; // last knife attribute value written to the server

  function cartJsUrl() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root + 'cart.js';
    }
    return '/cart.js';
  }

  function cartUpdateUrl() {
    if (window.routes && routes.cart_update_url) return routes.cart_update_url;
    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root + 'cart/update.js';
    }
    return '/cart/update.js';
  }

  function gates() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-ng-checkout-gate]'));
  }

  function knifeGates() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-ng-knife-gate]'));
  }

  function checkoutButtons() {
    return Array.prototype.slice.call(
      document.querySelectorAll(
        '#checkout[data-ng-gate-button], #CartDrawer-Checkout[data-ng-gate-button], .cart__checkout-button[data-ng-gate-button]'
      )
    );
  }

  function isRequired() {
    return currentTotalCents !== null && currentTotalCents >= THRESHOLD_CENTS;
  }

  function isKnifeRequired() {
    return hasKnife === true;
  }

  function isKnifeBlocked() {
    return isKnifeRequired() && knifeConfirmed !== true;
  }

  function isBlocked() {
    return (isRequired() && confirmed !== true) || isKnifeBlocked();
  }

  function apply() {
    var required = isRequired();
    var blocked = isBlocked();

    gates().forEach(function (gate) {
      gate.hidden = !required;
      var checkbox = gate.querySelector('[data-ng-gate-checkbox]');
      if (checkbox) checkbox.checked = required && confirmed === true;
      var attributeInput = gate.querySelector('[data-ng-gate-attribute]');
      if (attributeInput) attributeInput.value = required && confirmed === true ? 'yes' : '';
    });

    var knifeRequired = isKnifeRequired();
    knifeGates().forEach(function (gate) {
      gate.hidden = !knifeRequired;
      var checkbox = gate.querySelector('[data-ng-knife-checkbox]');
      if (checkbox) checkbox.checked = knifeRequired && knifeConfirmed === true;
      var attributeInput = gate.querySelector('[data-ng-knife-attribute]');
      if (attributeInput) attributeInput.value = knifeRequired && knifeConfirmed === true ? 'yes' : '';
    });

    checkoutButtons().forEach(function (button) {
      var emptyCart = currentItemCount !== null && currentItemCount === 0;
      if (blocked || emptyCart) {
        button.disabled = true;
      } else {
        button.disabled = false;
      }
      button.classList.toggle('ng-gate-disabled', blocked);
      if (blocked) {
        button.setAttribute('aria-disabled', 'true');
      } else {
        button.removeAttribute('aria-disabled');
      }
    });

    document.body.classList.toggle('ng-gate-blocked', blocked);
  }

  function syncAttribute() {
    var value = isRequired() && confirmed === true ? 'yes' : '';
    if (value === lastSyncedValue) return;
    lastSyncedValue = value;
    var attributes = {};
    attributes[ATTRIBUTE_KEY] = value;
    fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
      credentials: 'same-origin',
    }).catch(function () {
      /* The hidden cart-attribute input in the form still carries the
         value on checkout submit, so a failed sync is not fatal. */
      lastSyncedValue = null;
    });
  }

  function syncKnifeAttribute() {
    var value = isKnifeRequired() && knifeConfirmed === true ? 'yes' : '';
    if (value === lastKnifeSyncedValue) return;
    lastKnifeSyncedValue = value;
    var attributes = {};
    attributes[KNIFE_ATTRIBUTE_KEY] = value;
    fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
      credentials: 'same-origin',
    }).catch(function () {
      /* The hidden cart-attribute input in the form still carries the
         value on checkout submit, so a failed sync is not fatal. */
      lastKnifeSyncedValue = null;
    });
  }

  function refreshFromServer() {
    return fetch(cartJsUrl(), { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        currentTotalCents = cart.total_price;
        currentItemCount = cart.item_count;
        var serverValue = cart.attributes && cart.attributes[ATTRIBUTE_KEY] === 'yes' ? 'yes' : '';
        var knifeServerValue =
          cart.attributes && cart.attributes[KNIFE_ATTRIBUTE_KEY] === 'yes' ? 'yes' : '';
        if (isRequired()) {
          /* At or over $100: adopt a saved confirmation only on the
             first read; after that the in-memory state rules. */
          if (confirmed === null) confirmed = serverValue === 'yes';
        } else {
          /* Below $100 (item removed, quantity reduced, cart emptied):
             any earlier confirmation is void. Forget it locally AND
             clear it on the server — otherwise the stale "yes" would
             pre-confirm a later $100+ cart. */
          confirmed = false;
        }
        if (isKnifeRequired()) {
          /* A knife is in the cart: adopt a saved acknowledgment only
             on the first read; after that the in-memory state rules. */
          if (knifeConfirmed === null) knifeConfirmed = knifeServerValue === 'yes';
        } else if (hasKnife === false) {
          /* No knife in the cart (item removed, cart emptied): any
             earlier acknowledgment is void. Forget it locally AND
             clear it on the server — otherwise the stale "yes" would
             pre-acknowledge a later knife purchase. */
          knifeConfirmed = false;
        }
        /* Baseline the sync on the value the server actually holds, so
           syncAttribute() POSTs whenever the desired value differs —
           including the forced clear below $100. (Previously the sync
           only ran on checkbox changes, and refreshes adopted the
           server attribute unconditionally, so a "yes" stamped at
           $100+ survived emptying the cart and bypassed the gate for
           the next $100+ cart.) */
        lastSyncedValue = serverValue;
        lastKnifeSyncedValue = knifeServerValue;
        apply();
        syncAttribute();
        syncKnifeAttribute();
      })
      .catch(function () {
        apply();
      });
  }

  /* Checkbox toggles (event delegation survives AJAX cart re-renders). */
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target && target.matches && target.matches('[data-ng-gate-checkbox]')) {
      confirmed = target.checked;
      apply();
      syncAttribute();
    }
    if (target && target.matches && target.matches('[data-ng-knife-checkbox]')) {
      knifeConfirmed = target.checked;
      apply();
      syncKnifeAttribute();
    }
  });

  /* Dawn publishes a cart-update event after quantity changes, quick adds,
     and other cart mutations — re-read the cart so the gate tracks the
     live total crossing the $100 line in either direction. */
  var refreshTimer = null;
  function scheduleRefresh() {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshFromServer, 350);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleRefresh);
  }

  /* Section re-renders (cart drawer especially) replace the gate markup
     wholesale, resetting the checkbox element. Re-apply our state to any
     new gate/button DOM without another network round-trip, adopting the
     freshly rendered Liquid total when one appears. */
  var observer = new MutationObserver(function () {
    var found = gates();
    if (found.length) {
      var renderedTotal = parseInt(found[0].getAttribute('data-total-cents'), 10);
      if (!isNaN(renderedTotal) && renderedTotal !== currentTotalCents) {
        /* A re-render carrying a NEW total (e.g. the drawer after an
           item removal) — adopt it and re-read the server cart, so a
           drop below $100 actively clears the confirmation attribute
           even if no cartUpdate event fires. */
        currentTotalCents = renderedTotal;
        scheduleRefresh();
      }
    }
    var foundKnife = knifeGates();
    if (foundKnife.length) {
      var renderedKnife = foundKnife[0].getAttribute('data-has-knife') === 'true';
      if (renderedKnife !== hasKnife) {
        /* A re-render carrying a NEW knife state (a knife item was
           added or removed) — adopt it and re-read the server cart, so
           adding or removing a knife toggles the acknowledgment gate
           and its attribute even if no cartUpdate event fires. */
        hasKnife = renderedKnife;
        scheduleRefresh();
      }
    }
    apply();
  });

  function init() {
    /* Server-rendered total gives the correct first paint. */
    var found = gates();
    if (found.length) {
      var renderedTotal = parseInt(found[0].getAttribute('data-total-cents'), 10);
      if (!isNaN(renderedTotal)) currentTotalCents = renderedTotal;
    }
    /* Server-rendered knife state gives the correct first paint. */
    var foundKnife = knifeGates();
    if (foundKnife.length) {
      hasKnife = foundKnife[0].getAttribute('data-has-knife') === 'true';
    }
    apply();
    refreshFromServer();
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
